/**
 * Helpers for uploading multiple images and/or PDFs to OCR.
 * Returns the array shape the backend expects: [{image_base64, image_mime}, ...]
 */

const fileToBase64 = (file) =>
  new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onload = () => {
      const result = r.result || "";
      const comma = result.indexOf(",");
      resolve({
        base64: comma >= 0 ? result.slice(comma + 1) : result,
        mime: file.type || "application/octet-stream",
        name: file.name,
        size: file.size,
      });
    };
    r.onerror = reject;
    r.readAsDataURL(file);
  });

const isAccepted = (file) => {
  const t = (file.type || "").toLowerCase();
  return t.startsWith("image/") || t === "application/pdf";
};

/** Convert a FileList (or array) into the backend payload shape. */
export const filesToOcrPayload = async (fileList) => {
  const files = Array.from(fileList || []).filter(isAccepted);
  if (files.length === 0) {
    throw new Error("Please upload images (JPG/PNG/WEBP) or PDFs.");
  }
  const items = await Promise.all(files.map(fileToBase64));
  return {
    images: items.map(({ base64, mime }) => ({
      image_base64: base64,
      image_mime: mime,
    })),
    previews: items.map((it) => ({
      ...it,
      previewUrl:
        it.mime.startsWith("image/")
          ? `data:${it.mime};base64,${it.base64}`
          : null,
    })),
  };
};

/** First image base64 (for thumbnail/legacy single-image storage on a bill/receipt). */
export const firstImageOf = (payload) =>
  payload?.images?.[0]
    ? {
        image_base64: payload.images[0].image_base64,
        image_mime: payload.images[0].image_mime,
      }
    : null;
